import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import logoNR from '@/assets/logo-nr.png';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const menuItems = [
    { label: 'Accueil', path: '/' },
    { label: 'Nos services', path: '/services' },
    { label: 'Blog', path: '/blog' },
    { label: 'Tarifs', path: '/pricing' },
    { label: 'Intégrations', path: '/integrations' },
    { label: 'Suivi de colis', path: '/track' },
    { label: 'À propos', path: '/about' },
    { label: 'FAQ', path: '/faq' },
    { label: 'Contact', path: '/contact' },
  ];

  const scrollToTop = () => {
    window.setTimeout(() => window.scrollTo({ top: 0, left: 0, behavior: 'auto' }), 0);
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-white border-b border-gray-200 shadow-sm">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between gap-4 h-16">
          {/* Logo */}
          <Link to="/" onClick={scrollToTop} className="flex items-center hover:opacity-90 transition">
            <img src={logoNR} alt="Logo" className="w-32 h-auto object-contain" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex flex-1 items-center justify-center gap-5">
            {menuItems.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                end={item.path === '/'}
                onClick={scrollToTop}
                className={({ isActive }) =>
                  `whitespace-nowrap text-[15px] font-medium transition-colors ${
                    isActive ? 'text-red-600' : 'text-gray-700 hover:text-red-600'
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          {/* Desktop Login Button */}
          <div className="hidden lg:block">
            <Button
              className="bg-red-600 px-2.5 py-2 text-[13px] text-white hover:bg-red-700"
              onClick={() => {
                if (window.location.pathname === '/') {
                  document.getElementById('auth-section')?.scrollIntoView({ behavior: 'smooth' });
                } else {
                  navigate('/#auth-section');
                }
              }}
            >
              Se connecter
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 text-gray-700 hover:text-red-600 transition-colors"
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <div className="lg:hidden py-3 border-t border-gray-200 animate-in slide-in-from-top">
            <nav className="flex flex-col gap-1.5">
              {menuItems.map((item) => (
                <NavLink
                  key={item.path}
                  to={item.path}
                  end={item.path === '/'}
                  onClick={() => {
                    setMobileMenuOpen(false);
                    scrollToTop();
                  }}
                  className={({ isActive }) =>
                    `font-medium py-1.5 transition-colors ${
                      isActive ? 'text-red-600' : 'text-gray-700 hover:text-red-600'
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              ))}
              <Button
                onClick={() => {
                  setMobileMenuOpen(false);
                  if (window.location.pathname === '/') {
                    document.getElementById('auth-section')?.scrollIntoView({ behavior: 'smooth' });
                  } else {
                    navigate('/#auth-section');
                  }
                }}
                className="mt-1 bg-red-600 text-white hover:bg-red-700 w-full font-semibold px-4 py-2.5"
              >
                Se connecter
              </Button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
